class TryOnFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    console.log("init");

    this.debouncedOnSubmit = debounce((event) => {
      console.log("deboucned submit");
      document.querySelector("#fittingbox-collection-page .loading").style.display = "block";
      this.onSubmitHandler(event);
    }, 500);

    this.debouncedOnInput = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnInput.bind(this));
    this.querySelector('.filter-group-display__submit button')?.addEventListener('click', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : TryOnFiltersForm.searchParamsInitial;
      if (searchParams === TryOnFiltersForm.searchParamsPrev) return;
      TryOnFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {

    TryOnFiltersForm.searchParamsPrev = searchParams;
    const sections = TryOnFiltersForm.getSections();

    sections.forEach(() => {
      const url = `${window.location.pathname}?${searchParams}`;
      const filterDataUrl = element => element.url === url;

      TryOnFiltersForm.filterData.some(filterDataUrl) ?
        TryOnFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        TryOnFiltersForm.renderSectionFromFetch(url, event);
    });

    if (event.target.id != "Filter__Paginate") {
      if (updateURLHash) TryOnFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    document.querySelector("#fittingbox-collection-page .fittingbox-filter-popup").classList.add("loading");

    fetch(url)
      .then(response => {
        return response.text();
      })
      .then((html) => {
        TryOnFiltersForm.filterData = [...TryOnFiltersForm.filterData, { html, url }];
        TryOnFiltersForm.renderFilters(html, event);
        if (event.target.id == "Filter__Submit" || event.target.id == "Filter__Reset" || event.target.id == "Filter__Paginate" || event.target.id.includes("__Chat")) {
          TryOnFiltersForm.renderProductGridContainer(html, event.target.id);
        }
        TryOnFiltersForm.renderProductCount(html);
      }).finally(() => {
        document.querySelector("#fittingbox-collection-page .loading").style.display = "none";
        if (event.target.id == "Filter__Submit" || event.target.id == "Filter__Reset") {
          document.querySelector("#fittingbox-collection-page .color-selection").style.display = "none";
          document.querySelector("#fittingbox-collection-page .fittingbox-filter-popup").style.display = "none";
        }
        document.querySelector("#fittingbox-collection-page .fittingbox-filter-popup").classList.remove("loading");
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    document.querySelector("#fittingbox-collection-page .fittingbox-filter-popup").classList.add("loading");

    const html = TryOnFiltersForm.filterData.find(filterDataUrl).html;
    TryOnFiltersForm.renderFilters(html, event);

    if (event.target.id == "Filter__Submit" || event.target.id == "Filter__Reset" || event.target.id == "Filter__Paginate" || event.target.id.includes("__Chat")) {
      TryOnFiltersForm.renderProductGridContainer(html, event.target.id);
    }
    TryOnFiltersForm.renderProductCount(html);
    document.querySelector("#fittingbox-collection-page .loading").style.display = "none";
    if (event.target.id == "Filter__Submit" || event.target.id == "Filter__Reset") {
      document.querySelector("#fittingbox-collection-page .fittingbox-filter-popup").style.display = "none";
    }

    document.querySelector("#fittingbox-collection-page .fittingbox-filter-popup").classList.remove("loading");
  }

  static renderProductGridContainer(html, eventTargetId) {
    if (eventTargetId == "Filter__Paginate") {
      // append new products
      document.querySelector('.fittingbox-product-list .fittingbox-product-list-grid').innerHTML += new DOMParser().parseFromString(html, 'text/html').querySelector('.fittingbox-product-list .fittingbox-product-list-grid').innerHTML;
      // append pagination button
      document.querySelector('.fittingbox-product-list .container.facet-paginate-container').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.fittingbox-product-list .container.facet-paginate-container').innerHTML;
    } else {
      document.querySelector('.fittingbox-product-list').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.fittingbox-product-list').innerHTML;
    }
    tryOnInit(false, true);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    container.innerHTML = count;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#TryOnFiltersForm .js-filter, #FacetChatFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    TryOnFiltersForm.renderCounts(parsedHTML, document.getElementById('TryOnFiltersForm'));
  }

  static renderCounts(source, target) {
    const targetElement = target && target.querySelector('.facets__selected');
    const sourceElement = source && source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.querySelector('.fittingbox-product-list-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    TryOnFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    TryOnFiltersForm.renderPage(url, event);
  }
}

TryOnFiltersForm.filterData = [];
TryOnFiltersForm.searchParamsInitial = window.location.search.slice(1);
TryOnFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('try-on-filters-form', TryOnFiltersForm);
TryOnFiltersForm.setListeners();

class TryOnRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('try-on-filters-form') || document.querySelector('try-on-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('try-on-remove', TryOnRemove);

class FacetPaginate extends HTMLElement {
  constructor() {
    super();
    this.url_previous = "";

    this.debouncedOnPaginate = debounce((event) => {
      this.onPaginateHandler(event);
    }, 500);

    this.querySelector("a.next")?.addEventListener("click", this.debouncedOnPaginate.bind(this));

    var $scrollElem = $(".fittingbox-product-list, .fittingbox-product-list-wrapper");
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });

    $scrollElem.on("scroll", function (e) {
      e.preventDefault();

      var $nextElem = this.querySelector("a.next"),
        scrolled = false;

      if ($nextElem && isInViewport($nextElem) && !scrolled) {
        $nextElem.innerHTML = `<svg viewBox="0 0 100 100" class="Icon Icon--Loading">
                <g transform="rotate(0 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(30 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(60 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(90 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(120 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(150 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(180 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(210 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(240 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(270 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(300 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/>
                  </rect>
                </g><g transform="rotate(330 50 50)">
                  <rect x="47" y="24" rx="3" ry="3" width="6" height="12" fill="#5b5b5b">
                    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/>
                  </rect>
                </g>
              </svg>`;
        $nextElem?.dispatchEvent(clickEvent);
        scrolled = true;
      }
    });
  }

  onPaginateHandler(event) {
    event.preventDefault();
    const url = event.target.rel.indexOf('?') == -1 ? '' : event.target.rel.slice(event.target.rel.indexOf('?') + 1);
    if (url && url != FacetPaginate.url_previous) {
      FacetPaginate.url_previous = url; // To prevent dublicate url which then dublicates the products
      TryOnFiltersForm.renderPage(url, event, false);
    }
  }
}

customElements.define('facet-paginate', FacetPaginate);

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}